import React from "react";
import {Button, Row, Col} from "react-bootstrap";
import Component from "../../components/AscComponent";
import CommonTable from "../Elements/Table/CommonTable";
import ProperNounDeleteModal from "./ProperNounDeleteModal";
import ProperNounInsertModal from "./ProperNounInsertModal";
// import ProperNounUpdateModal from "./ProperNounUpdateModal";
import ProperNounReadModal from "./ProperNounReadModal";

export default class ProperNoun extends Component {
    constructor(props) {
        super(props);

        this.state = {
            // table item
            columns: [], // 動的に設定するため初期は空配列
            data: [],
            pageSize: 20, // ページサイズを追加
            pages: null,
            loading: false,
            filtered: [],
            sorted: [{id: "id", desc: true}],
            pageIndex: 0,
            pageCount: 0,

            // modal item
            show: false,
            modalType: null,
            selectedData: [],

            // form data
            hints: "",
            token_count: "",
            created: "",
            tokenCount: 0,
            totalTokens: 0,
            totalTokensLimitCnt: 150,
            registeredDate: "",
            token_flag: true
        };
        this.getTotalTokenCount();
    }

    async componentDidMount() {
        // 初期カラム設定
        this.updateColumns();
    }

    /**
     * 一覧表作成（動的にカラムを生成）
     */
    getColumnsData() {
        return [
            {
                Header: this.props.langText.Body.Noun,
                accessor: "hints",
            }, {
                Header: `${this.props.langText.Body.TokenCnt} (${this.state.totalTokens}/${this.state.totalTokensLimitCnt})`,
                accessor: "token_count",
                Cell: data => {
                    if (data && data.row && data.row.original) {
                        return data.row.original.token_count
                    } else {
                        return "";
                    }
                }
            }, {
                Header: this.props.langText.Body.RegisteredDate,
                accessor: "created",
                Cell: data => {
                    const date = new Date(data.row.original.created);
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const day = String(date.getDate()).padStart(2, '0');
                    return `${year}/${month}/${day}`;
                }
            }
        ]
    }

    /**
     * カラムを更新する
     */
    updateColumns = () => {
        this.setState({
            columns: this.getColumnsData()
        });
    }


    /**
     * モーダル表示分岐
     */
    getModalBranch() {
        switch (this.state.modalType) {
            case "insert":
                return (
                    <ProperNounInsertModal
                        onHide={() => this.setState({show: false})}
                        onClick = {this.onClickHandle}
                        validationHandle = {this.validationHandle}
                        state={this.state}
                        onTextChange={this.onTextChange}
                        onFileChange={this.onFileChange}
                        langText={this.props.langText}
                        propSetState = {this.propSetState}
                        charaLimit = {this.props.charaLimit}
                        onTextChange_Limit = {this.onTextChange_Limit}
                        getTokenCount={this.getTokenCount}
                    />
                );
            // case "update":
            //     return (
            //         <ProperNounUpdateModal
            //             onHide={() => this.setState({show: false})}
            //             onClick = {this.onClickHandle}
            //             validationHandle = {this.validationHandle}
            //             state={this.state}
            //             onTextChange={this.onTextChange}
            //             onFileChange={this.onFileChange}
            //             langText={this.props.langText}
            //             propSetState = {this.propSetState}
            //             charaLimit = {this.props.charaLimit}
            //             onTextChange_Limit = {this.onTextChange_Limit}
            //         />
            //     );
            case "delete":
                return (
                    <ProperNounDeleteModal
                        onHide={() => this.setState({show: false})}
                        onClick = {this.onClickHandle}
                        validationHandle = {this.validationHandle}
                        state={this.state}
                        langText={this.props.langText}
                        propSetState = {this.propSetState}
                    />
                );
            case "read":
                return (
                    <ProperNounReadModal
                        onHide={() => this.setState({show: false})}
                        onClick = {this.onClickHandle}
                        validationHandle = {this.validationHandle}
                        state={this.state}
                        langText={this.props.langText}
                        propSetState = {this.propSetState}
                    />
                );
            default:
                return null;
        }
    }

    /**
     * モーダル表示
     */
    modalShow = (modalType) => async event => {
        let { selectedData } = this.state;
        event.preventDefault();
        let rowInfo = '';
        //ひとつだけ選択して編集または削除ボタンを押した場合
        if (modalType === "update" || modalType === "read" || (modalType === "delete" && selectedData.length === 1)) {
            rowInfo = selectedData.slice().pop();
        } 
        //編集・削除の場合一つ以上の項目選択必須
        if((modalType === "update" || modalType === "read" || modalType === "delete" ) && selectedData.length === 0){
            return this.showErrorObjectMessage('ModalSelectError');
        }
        //編集の場合一つの項目だけ選択可能
        if((modalType === "update" || modalType === "read") && selectedData.length > 1){
            return this.showErrorObjectMessage('UpdateModalSelectError');
        }
        // #613: 一覧はページ単位で返るため、トークン合計は表示中の行からではなく全件の合計（/getTokensTotal）を使う。
        // 他の画面・利用者の登録を反映するため、登録モーダルを開くたびに取り直す
        let totalTokens = this.state.totalTokens;
        if (modalType === "insert") {
            const latestTotal = await this.getTotalTokenCount();
            if (latestTotal !== undefined) {
                totalTokens = latestTotal;
            }
        }
        //登録トークン数が制限数を超えている場合
        if((modalType === "insert") && totalTokens >= this.state.totalTokensLimitCnt){
            return this.showErrorObjectMessage('ProperNoun_TokenCnt_Error');
        }

        let setData = {
            hints: rowInfo && rowInfo.hints
                ? rowInfo.hints
                : "",
            token_count: rowInfo && rowInfo.token_count
                ? rowInfo.token_count
                : "",
            modalType: modalType,
            show: true
        }

        setData.tokenCount = 0;
        setData.totalTokens = totalTokens;

        if (modalType === "delete") {
            let selectedData = this.state.selectedData;
            setData.id = selectedData.map(row => row.id);
            setData.hints = selectedData.map(row => row.hints);
        }

        this.setState(setData);
    };

    getTokenCount = async (event) => {
        try {
            let tokenCount = this.state.tokenCount;
            if(event && event.length !== 0 && event.length <= this.props.charaLimit.ProperNoun_ProperNounHints){
                const response = await this.ascAxios('post', `${this.reactContainerPath}/countTokens`, {
                    hints: event
                }); 
                tokenCount = response.data;
            } else if (event.length === 0) {
                tokenCount = 0;
            }
            this.setState({
                tokenCount: tokenCount
            });
            this.tokenLimitCheck(tokenCount);
        } catch (err) {
            console.error(err);
        }
    }

    getTotalTokenCount = async () => {
        try {
            const response = await this.ascAxios('post', `${this.reactContainerPath}/getTokensTotal`);
            // Anywhere は合計を文字列（例: "8"）で返すため数値へ直す。
            // 合計が 0 のときも反映する（全件削除後に前の値が残らないように）
            const total = response && response.data !== "" && response.data !== null
                ? Number(response.data)
                : NaN;
            if (Number.isFinite(total)) {
                this.setState({
                    totalTokens: total
                }, () => {
                    // totalTokensが更新された後にカラムを更新
                    this.updateColumns();
                });
                return total;
            }
        } catch (err) {
            console.error(err);
        }
        return undefined;
    }

    /**
     * 各画面先でのボタン押下時の動作内容
     */
    onClickHandle = modalType => async () => {
        let {
            id,
            hints
        } = this.state;

        try {
            switch (modalType) {
                case 'insert':
                    this.blockUI();
                    await this.ascAxios('post', `${this.reactContainerPath}/insert`, {
                        hints
                    });
                    alert(this.props.langText.Message.DataInsertSuccess);
                    this.reactTableRefresh(true);
                    await this.getTotalTokenCount(); // awaitを追加してカラム更新を待つ
                    break;
                // case 'update':
                //     this.blockUI();
                //     await this.ascAxios('post', `${this.reactContainerPath}/update`, {
                //         hints
                //     });
                //     alert(this.props.langText.Message.DataUpdateSuccess);
                //     this.reactTableRefresh(true);
                //     break;
                case 'delete':
                    this.blockUI();
                    await this.ascAxios('post', `${this.reactContainerPath}/delete`, {
                        id
                    });
                    alert(this.props.langText.Message.DataDeleteSuccess);
                    this.reactTableRefresh(true);
                    await this.getTotalTokenCount(); // awaitを追加してカラム更新を待つ
                    break;
                default:
                    this.showErrorObjectMessage('ModalTypeError');
            }
        } catch (err) {
            console.error(err);
            this.showErrorObjectMessage(err);
        } finally {
            this.setState({show: false});
        }
    };

    /**
     * 各画面のボタン押下条件
     */
    validationHandle = param => {
        let validation_flag = false;
        let {
            id,
            hints
        } = this.state;

        switch (param) {
            case "insert":
            // case "update":
                validation_flag = !!(hints) && this.state.token_flag;
                break;
            case "delete":  
                validation_flag = !!(id);
                break;
            case "read":
                validation_flag = !!(id);
                break;
            default:
                break;
        }

        return validation_flag;
    };

    tokenLimitCheck = (tokenCount) => {
        if (tokenCount !== 0 && 
            tokenCount >= (this.state.totalTokensLimitCnt-this.state.totalTokens)) {
            this.setState({token_flag: false});
        } else {
            this.setState({token_flag: true});
        }
    }

    render() {
        return (
            <div className="ProperNoun">
                {/*一覧画面*/}
                <Row>
                    <Col xs={12} md={12}>
                        <Button
                            id = "propernouns-insert"
                            className = "table-button"
                            variant = "default"
                            size = "sm"
                            onClick={this.modalShow("insert")}
                            hidden={!this.props.currentPermission.create}
                        >
                            {this.props.langText.Body.InsertTitle}
                        </Button>
                        {/* <Button
                            id = "propernouns-update"
                            className = "table-button"
                            variant = "default"
                            size = "sm"
                            onClick={this.modalShow("update")}
                            hidden={!this.props.currentPermission.update}
                        >
                            {this.props.langText.Body.UpdateTitle}
                        </Button> */}
                        <Button
                            id = 'propernouns-read'
                            className = 'table-button'
                            variant = 'default'
                            size = 'sm'
                            onClick={this.modalShow('read')}
                            hidden={!!this.props.currentPermission.update}
                            disabled={!(this.state.selectedData.length === 1)}
                        >
                            {this.props.langText.Body.ReadTitle}
                        </Button>
                        <Button
                            id = "propernouns-delete"
                            className = "table-button"
                            variant = "default"
                            size = "sm"
                            onClick={this.modalShow("delete")}
                            hidden={!this.props.currentPermission.delete}
                            disabled={this.state.selectedData.length === 0}
                        >
                            {this.props.langText.Body.DeleteTitle}
                        </Button>
                    </Col>
                    <Col xs={12} md={12}>
                        <CommonTable
                            showPageSize={true}
                            showCheckbox={true}
                            showPagination={true}
                            propsPageIndex = {this.state.pageIndex? this.state.pageIndex: 0}
                            state = {this.state}
                            tableHeight={this.props.tableHeight}
                            tbodyHeight={this.props.tableHeight-30}
                            columns={this.state.columns}
                            data={this.state.data}
                            pageSize={this.state.pageSize} // pageSize プロパティを追加
                            loading={this.state.loading}
                            onFetchData={this.fetchData}
                            filtered={this.state.filtered}
                            sorted={this.state.sorted}
                            pageCount = {this.state.pageCount}
                            manual = {true}
                            langText = {this.props.langText.Table}
                            onSelectedDataChange={(selected) => {
                                this.setState({ selectedData: selected });
                            }}
                        />
                    </Col>
                </Row>
                {/*モーダル表示分岐*/}
                {this.getModalBranch()}
            </div>
        );
    }
} 